import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/shared/constants/constants.constant';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { SecurityService } from 'src/app/core/services/security.service';
import { SystemAvailabilityApiService } from '../services/system-availability-api.service';

@Component({
	selector: 'app-service-not-accessible',
	templateUrl: './service-not-accessible.component.html',
	standalone: false,
})
export class ServiceNotAccessibleComponent implements OnInit {
	displayNotes: string;

	constructor(
		private appContext: AppContextService,
		private securityService: SecurityService,
		private systemAvailabilityApiService: SystemAvailabilityApiService
	) {
		this.appContext.ViewTitle = 'Service not Available';
		this.appContext.BasePageCSSClass.set(Constants.BasePageCSSClass.Default);
	}

	ngOnInit(): void {
		this.systemAvailabilityApiService.getSystemAvailabilityNotes().subscribe(x => {
			this.displayNotes = x ?? 'SpyderFlow is currently unavailable; please try again later or contact support for more information.';
			this.securityService.clearUser();
		});
	}
}
